import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { cachedSerialNames31jc5fovi62px as cachedSerialNames } from './Platform.common.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var NullableSerializerClass;
function NullableSerializer() {
  if (NullableSerializerClass === VOID) {
    class $ {
      constructor(serializer) {
        this.t1z_1 = serializer;
        this.u1z_1 = new (SerialDescriptorForNullable())(this.t1z_1.m1m());
      }
      m1m() {
        return this.u1z_1;
      }
      v1z(encoder, value) {
        if (!(value == null)) {
          encoder.z1s();
          encoder.w1s(this.t1z_1, value);
        } else {
          encoder.z1r();
        }
      }
      n1m(encoder, value) {
        return this.v1z(encoder, value);
      }
      o1m(decoder) {
        return decoder.o1q() ? decoder.c1r(this.t1z_1) : decoder.p1q();
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof NullableSerializer()))
          THROW_CCE();
        if (!equals(this.t1z_1, other.t1z_1))
          return false;
        return true;
      }
      hashCode() {
        return hashCode(this.t1z_1);
      }
    }
    initMetadataForClass($, 'NullableSerializer', VOID, VOID, [KSerializer()]);
    NullableSerializerClass = $;
  }
  return NullableSerializerClass;
}
var SerialDescriptorForNullableClass;
function SerialDescriptorForNullable() {
  if (SerialDescriptorForNullableClass === VOID) {
    class $ {
      constructor(original) {
        this.c1p_1 = original;
        this.d1p_1 = this.c1p_1.p1n() + '?';
        this.e1p_1 = cachedSerialNames(this.c1p_1);
      }
      p1n() {
        return this.d1p_1;
      }
      m1q() {
        return this.e1p_1;
      }
      b1p() {
        return true;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SerialDescriptorForNullable()))
          return false;
        if (!equals(this.c1p_1, other.c1p_1))
          return false;
        return true;
      }
      toString() {
        return toString(this.c1p_1) + '?';
      }
      hashCode() {
        return imul(hashCode(this.c1p_1), 31);
      }
      i1p() {
        return this.c1p_1.i1p();
      }
      j1p() {
        return this.c1p_1.j1p();
      }
      k1p() {
        return this.c1p_1.k1p();
      }
      l1p() {
        return this.c1p_1.l1p();
      }
      m1p(index) {
        return this.c1p_1.m1p(index);
      }
      n1p(name) {
        return this.c1p_1.n1p(name);
      }
      o1p(index) {
        return this.c1p_1.o1p(index);
      }
      p1p(index) {
        return this.c1p_1.p1p(index);
      }
      q1p(index) {
        return this.c1p_1.q1p(index);
      }
    }
    initMetadataForClass($, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorForNullableClass = $;
  }
  return SerialDescriptorForNullableClass;
}
//region block: exports
export {
  NullableSerializer as NullableSerializer41etqlj0tdq5,
  SerialDescriptorForNullable as SerialDescriptorForNullable2slcv65za9oog,
};
//endregion

//# sourceMappingURL=NullableSerializer.mjs.map
